export const tabType = Object.freeze({
  agents: 'agents',
  tokens: 'tokens',
  profile: 'overview',
  emailConfiguration: 'emailConfiguration',
  companies: 'companies',
  users: 'users',
  groups: 'groups',
});

export const agentScheduleTabTypes = Object.freeze({
  timeBased: 'timeBased',
  emailBased: 'emailBased',
});

export const timeBasedAgentScheduleTypes = Object.freeze({
  runOnce: 'runOnce',
  runRepeatedly: 'runRepeatedly',
});
